import { render, staticRenderFns } from "./Administrative.vue?vue&type=template&id=5749e0ee&"
import script from "./Administrative.vue?vue&type=script&lang=js&"
export * from "./Administrative.vue?vue&type=script&lang=js&"
import style0 from "./Administrative.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports